import { Box } from '@chakra-ui/react';

import { isMobileView } from 'constants/isMobileView';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

type CancelConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  modalAgenda?: string;
};

export const CancelConfirmationModal = ({
  isOpen,
  onClose,
  onContinue,
  modalAgenda = 'cancel',
}: CancelConfirmationModalProps) => (
  <ConfirmationModal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    title={modalAgenda === 'delete' ? 'Delete?' : 'Cancel?'}
    body={
      <Box>
        {modalAgenda === 'delete'
          ? 'Are you sure you want to delete the violation note?'
          : 'Are you sure you want to cancel the changes?'}
      </Box>
    }
    cancelText="No"
    onCancel={onClose}
    continueText="Yes"
    onContinue={onContinue}
    disabled={false}
    modalContentProps={{ w: `${isMobileView() ? '80vw' : '600px'}` }}
    cancelButtonProps={{}}
    continueButtonProps={{ disabled: false }}
    showTopCloseButton={false}
  />
);
